import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, FormControl, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { AdminService } from '../services/admin.service';
import { UserService } from '../services/user.service';
@Component({
    selector: 'app-fiatwithdrawrejectconfirm',
    templateUrl: './fiatwithdrawrejectconfirm.component.html',
    styleUrls: ['./fiatwithdrawrejectconfirm.component.css']
})
export class FiatWithdrawRejectDialog {
    element: any = {};
    myForm: any = FormControl;
    banks: any[] = [];
    restrictForReject: any;
    bank_active: any;
    selectedBankName: any;
    constructor(
        public dialogRef: MatDialogRef<FiatWithdrawRejectDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public fb: FormBuilder,
        public adminService: AdminService,
        public userService: UserService,
        public notificationService: NotificationsService,
    ) {
        this.element = data;
        this.restrictForReject = this.element['status'] === 'APPROVED' ? false : true;
        this.myForm = this.fb.group({
            // A bank is only needed to approve (it picks the payout route); rejecting doesn't use it
            bank_account_id: ['', this.restrictForReject ? [] : [Validators.required]],
            amount: ['', [Validators.required]],
            currency: ['', [Validators.required]],
            withdraw_fee: ['', [Validators.required, this.validateNonNegativeAndFee]],
            note: ['', [Validators.required]],
        });
        // Subscribe to changes in the 'currency' control to update the bank options
        this.myForm.get('currency').valueChanges.subscribe((currency) => {
            this.updateBankOptions(currency);
        });
        // Subscribe to changes in the 'bank_account_id' control to get the selected bank name
        this.myForm.get('bank_account_id').valueChanges.subscribe((bank_account_id) => {
            this.selectedBankName = this.getBankNameById(bank_account_id);

        });
        this.displayFormData();

    }
    updateBankOptions(currency: string) {
        this.userService.getBanks().subscribe((response) => {
            if (response && response.length > 0) {
                const wanted = String(currency || '').trim().toUpperCase();
                this.banks = response.filter(bank => String(bank.currency || '').trim().toUpperCase() === wanted);
                if (typeof this.banks == 'undefined') {
                    this.banks = []
                } else {
                    var bankActive = this.banks.find(e => e.is_default === true);
                    if (typeof bankActive == 'undefined') {
                        this.bank_active = '';
                    } else {
                        this.bank_active = bankActive._id;
                    }

                }
            }
        }, (err) => {
            this.notificationService.error('Error', 'Failed to load bank list', {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            });
        });
    }
    // Function to get the bank name from the banks array based on the bank_account_id
    getBankNameById(bank_account_id: any): string {
        const bank = this.banks.find((bank) => bank._id === bank_account_id);
        return bank ? bank.bank_name : '';
    }
    displayFormData() {
        this.myForm.controls['amount'].patchValue(this.element.amount);
        this.myForm.controls['currency'].patchValue(this.element.currency);
        this.myForm.controls['withdraw_fee'].patchValue(this.element.withdraw_fee);
    }
    confirmFiatWithdraw() {
        if (this.myForm.controls['withdraw_fee'].value > this.myForm.controls['amount'].value) {
            return this.notificationService.error('Fee should be less than amount');
        }
        if (this.myForm.valid) {

            this.userService.csrf().subscribe(csdata => {
                this.myForm.value['_csrf'] = csdata._csrf;
                this.myForm.value['_id'] = this.element._id;
                this.myForm.value['status'] = this.element.status;
                this.myForm.value['selectedBankName'] = this.selectedBankName;
                this.adminService.updateFiatbyAdmin(this.myForm.value).subscribe(data => {
                    // The backend answers 200 with status false when the update fails
                    if (data && data.status === false) {
                        this.notificationService.error('Error', data.message, {
                            timeOut: 3000,
                            showProgressBar: true,
                            pauseOnHover: false,
                            clickToClose: true,
                            maxLength: 50
                        });
                        return;
                    }
                    this.notificationService.success(
                        'Success',
                        data.message,
                        {
                            timeOut: 3000,
                            showProgressBar: true,
                            pauseOnHover: false,
                            clickToClose: true,
                            maxLength: 50
                        })
                    // Emit the form data when closing the dialog
                    this.dialogRef.close({ success: true, data: data });
                }, (err) => {
                    this.notificationService.error(err.message,
                        {
                            timeOut: 3000,
                            showProgressBar: true,
                            pauseOnHover: false,
                            clickToClose: true,
                            maxLength: 50
                        });
                })
            })
        }
    }
    // Custom validator function to validate non-negative fee and fee <= amount.
    validateNonNegativeAndFee: ValidatorFn = (control: AbstractControl) => {
        const amountValue = control.root.get('amount') ? control.root.get('amount').value : null;
        const feeValue = control.value;

        if (feeValue !== null && feeValue < 0) {
            return { nonNegative: true };
        }

        if (amountValue !== null && feeValue !== null && feeValue > amountValue) {
            return { feeExceededAmount: true };
        }

        return null;
    };
}


// WEBPACK FOOTER //
// ./src/app/fiatrejectconfirm/fiatwithdrawrejectconfirm.component.ts